import { OpportunityForbidden } from "./components/OpportunityForbidden";

export default OpportunityForbidden;